module.exports = "pegasus/assets/blocks/header-6-theme6.png";